<template>
  <a-layout-sider
    v-model="collapsedSoon"
    collapsible
    theme="light"
    width="275"
    :reverseArrow="true"
    :collapsedWidth="25"
    :defaultCollapsed="false"
    style="height: 100%; border-left: thin dotted;"
    >

    <a-card
      v-show="!collapsedSoon"
      :bordered="false"
      :class="{card: true}"
      >
      <div slot="title" style="line-height: 32px;">
       soon™
      </div>
      <draggable
        v-model="tasks"
        group="tasks"
        filter=".undragabble"
        @start="drag=true"
        @end="drag=false"
      >
        <p v-for="(task, i) in tasks" :key="task.id">
          <a-icon v-if="!userPreferences['layout.hideDragHandle']" type="ellipsis" class="drag-handle"></a-icon>
          <a-checkbox
            :checked="task.done"
            @change="onTaskCheckboxChange($event, task)"
          />
        <span
          :class="{taskSpan: true, done: task.done}"
          contentEditable="true"
          v-text="task.text"
          :ref="'taskSpans'"
          @keypress="onTaskSpanKeyPress"
          @keydown="onTaskSpanKeyDown($event, task, i)"
          @keyup="onTaskSpanKeyUp($event, task, i)"
          @blur="onTaskSpanBlur($event, task)"
        />
        </p>
        <p slot="footer" class="undragabble">
          <span @click.stop="onPlusClick" class="addTask">
            <a-icon type="plus" /> Add task
          </span>
        </p>
      </draggable>
    </a-card>

    <div
      v-show="collapsedSoon"
      class="soonTrigger"
      @click="collapsedSoon=!collapsedSoon;"
    >
      <span v-if="collapsedSoon">soon<span style="writing-mode: horizontal-tb; transform: rotate(90deg)">™</span></span>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import { debounce } from 'debounce';
import { setEndOfContenteditable, shortId } from '@/utils';

export default {
  name: "Soon",
  components: {
    draggable,
  },
  computed: {
    soonObject: {
      get() {
        return this.$store.getters["soon/getSoon"]();
      },
      set(value) {
        this.$store.commit(
          'soon/SetSoon',
          {soon: value},
        );
      }
    },

    tasks: {
      get() {
        return this.soonObject.tasks;
      },
      set(value) {
        this.$store.commit(
          'soon/editSoon',
          {soonObject: this.soonObject, key: "tasks", value: value},
        );
        this.onSoonUpdated();
      }
    },
    ...mapGetters({
      userPreferences: 'prefs/getUserPreferences',
    }),
  },
  created() {
    this.$store.dispatch("soon/fetchSoon")
    this.saveSoonDebounced = debounce(this.saveSoon, 3000);
  },
  data() {
    return {
      collapsedSoon: true,
      console: console,
    }
  },
  methods: {
    onSoonUpdated(){
      this.saveSoonDebounced();
    },

    saveSoon(){
      this.$store.dispatch('soon/saveSoon');
    },

    addNewTask(position) {
      const newId = shortId();
      const newTask = {id: newId, text: "", done: false};
      this.$store.commit(
        'soon/addTask',
        {soonTasks: this.tasks, position, task: newTask}
      );
      this.onSoonUpdated();

      this.$nextTick(() => {
        this.$refs.taskSpans[this.tasks.length - 1].focus()
        }
      );
    },
    removeTask(position) {
      this.$store.commit(
        'soon/removeTask',
        {soonTasks: this.tasks, position}
      );
      this.focusTask(position - 1);
      this.onSoonUpdated();
    },

    focusTask(position) {
      if (position < 0 || position >= this.tasks.length) return;
      const compare = (a, b) => a.offsetTop-b.offsetTop;
      const spanAtPosition = this.$refs.taskSpans.sort(compare)[position];
      spanAtPosition.focus();
      setEndOfContenteditable(spanAtPosition);
    },

    onPlusClick() {
      this.addNewTask(this.tasks.length);
    },

    onTaskCheckboxChange(event, task) {
      this.$store.commit(
        'soon/editTask',
        {task, key: "done", value: event.target.checked}
      );
      this.onSoonUpdated();
    },

    onTaskSpanBlur(event, task) {
      this.$store.commit(
        'soon/editTask',
        {task, key: "text", value: event.target.textContent}
      );
      this.onSoonUpdated();
    },

    onTaskSpanKeyPress(event) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        event.preventDefault();
      }
    },

    onTaskSpanKeyDown(event, task, position) {
      //console.log(event);
      switch(event.key){
        case "Backspace":
          if (!event.target.textContent) {
            this.removeTask(position);
            event.preventDefault();
          }
          break;
        case "ArrowUp":
          this.focusTask(position - 1);
          event.preventDefault();
          break;
        case "ArrowDown":
          this.focusTask(position + 1);
          event.preventDefault();
          break;
      }

    },

    onTaskSpanKeyUp(event, task, position) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        this.addNewTask(position + 1);
      }
    },
  }
}
</script>

<style scoped>

[contenteditable]:focus {
    outline: 0px solid transparent;
}

p {
  text-align: left;
}

.done {
  text-decoration: line-through;
  color: #bbb;
}

.addTask {
  cursor: pointer;
}

.card {
  flex: 1;
  overflow-y: auto;
  max-height: 100vh;
}

.drag-handle {
  float: right;
  cursor: move;
}

.taskSpan {
  white-space: pre-wrap;
}

.soonTrigger {
  cursor: pointer;
  height: 100%;
  width: 100%;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: center;
}

</style>


